import { render, staticRenderFns } from "./VxTr.vue?vue&type=template&id=5dfc4afe"
import script from "./VxTr.vue?vue&type=script&lang=js"
export * from "./VxTr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports